import { ErrorHandler, inject, Injectable } from '@angular/core';
import { StoreType } from '@dice/app/types/store.type';
import { Store } from '@ngxs/store';
import { StateService } from '@uirouter/angular';
import { NGXLogger } from 'ngx-logger';

@Injectable({ providedIn: 'root' })
export class ErrorHandlingService extends ErrorHandler {
  private logger = inject(NGXLogger);
  private store = inject(Store);
  private stateService = inject(StateService);

  handleError(err): void {
    // send the error to the server
    customLogger.error(err);

    // https://angular.io/guide/service-worker-communications#handling-an-unrecoverable-state
    if (err.message && err.message.includes('ChunkLoadError')) {
      customLogger.log('Chunk not found/**/. Reloading page');
      const previousFullState = this.store.selectSnapshot<string>(
        (state: StoreType) => state.router?.createdState?.previousFullState,
      );
      const href = this.stateService.href(previousFullState);
      const url = `${window.location.protocol}//${window.location.host}/${href}`;
      window.location.replace(url);
      window.location.reload();
    }
    // delegate to the default handler
    super.handleError(err);
  }
}
